import React from 'react'

const DeletedMessageMarker = () => (
  <span>
    {' '}
    Borrado <span className="fa fa-minus-circle red-primary" />{' '}
  </span>
)

export default DeletedMessageMarker
